import config from '@cof/ukweb-config/lib/clientConfig';
import { AGGREGATOR_CONSUMER_NAMES, AGGREGATOR_WITH_LOGO, API_PARTNERS, HOSTED_PARTNERS } from './constants';
import { FORM_SECTIONS } from '../pages/QuickCheck/Components/FormIDs';

export const isHosted = (brand: any) => {
    return HOSTED_PARTNERS.includes(brand);
};

export const hasAggregatorLogo = (consumerName: any) => {
    return AGGREGATOR_WITH_LOGO.includes(consumerName);
};

export const isAggregatorConsumer = (consumerName: any) => {
    return AGGREGATOR_CONSUMER_NAMES.includes(consumerName);
};

export const isApiPartner = (brand: any) => {
    return API_PARTNERS.includes(brand);
};

export const isPartnerOrAggsEdit = (brand: any, aggregatorConsumerName: any) =>
    isApiPartner(brand) || isAggregatorConsumer(aggregatorConsumerName);

// TODO - Clean up - remove this
export const useSinglePage = (brand: any, consumerName: any) => {
    return isApiPartner(brand) || isAggregatorConsumer(consumerName);
};

export const lookupWithDefault = (table: any, key: any, defaultKey = 'default') => table[key] || table[defaultKey];

export const addSParameterToLinkUrl = ({ url, sParameter }: any) => {
    const urlObj = new URL(url);
    if (sParameter) {
        urlObj.searchParams.set('s', sParameter);
    }
    return urlObj.toString();
};

export const maskParam = (url: any, param: any, maskValue = 'MASKED') => {
    const urlObj = new URL(url);
    if (urlObj.searchParams.get(param)) {
        if (param === 'quotation') {
            // @ts-expect-error TS2531: Object is possibly 'null'.
            urlObj.searchParams.get(param).length > 16
                ? urlObj.searchParams.set(param, 'STANDARD_TOKEN')
                : urlObj.searchParams.set(param, 'SHORT_TOKEN');
        } else urlObj.searchParams.set(param, maskValue);
    }
    return urlObj.toString();
};

export const maskAllHashParams = (url: any) => url.split('#')[0];

/**
 * Returns the value of a cookie
 * @param {string} k - The cookie key
 * @returns {string|undefined} The cookie value
 * See {@link https://developer.mozilla.org/en-US/docs/Web/API/Document/cookie#example_5_check_a_cookie_existence}
 */
export const parseCookie = (k: any) => {
    return document.cookie
        .split(';')
        .find((x) => x.trim().startsWith(`${k}=`))
        ?.split('=')[1];
};

export const removeAllWhitespace = (val: any) => val.replace(/\s+/g, '');

export const trimWhitespace = (val: any) => val.trim();

export const sendQuantumEvent = (eventID: any, conversion: any, primaryValue: any, attributes: any) => {
    // @ts-expect-error TS2345: Argument of type '"quantumMetric.isEnabled"' is not assignable to parameter of type '"adobeTarget" |
    if (config.get('quantumMetric.isEnabled') && window?.QuantumMetricAPI?.isOn()) {
        try {
            // @ts-expect-error TS2339: Property 'QuantumMetricAPI' does not exist on type 'Window & typeof globalThis'.
            window.QuantumMetricAPI.sendEvent(eventID, conversion, primaryValue, attributes);
        } catch (e) {
            // eslint-disable-next-line no-console
            // @ts-expect-error TS18046: 'e' is of type 'unknown'.
            console.log(e.message);
        }
    }
};

export const postcodeRegex =
    /^(?!im|je|gy|IM|JE|GY|iM|jE|gY|Im|Je|Gy)[a-zA-Z]{1,2}[0-9][0-9a-zA-Z]?\s?[0-9][a-zA-Z]{2}$/;

export const houseFlatNumberRegex = /^[A-Za-z0-9',.& /-]+$/;

export const getAriaDescribedBy = (id: any, submitAttempted: any, additionalInfoIDs = [], errors = {}) => {
    const errorMessage = `${id}-error-message`;
    // @ts-expect-error TS7053: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type ''
    const hasError = submitAttempted && errors[id];

    if (additionalInfoIDs.length === 0) {
        return hasError ? errorMessage : undefined;
    }
    const base = additionalInfoIDs.join(' ');
    return hasError ? `${base} ${errorMessage}` : base;
};

export const normalizeFormValues = (values: any) => {
    if (!values) return {};
    const normalized = { ...values };
    const checkboxFields = [FORM_SECTIONS.Permissions.Marketing, FORM_SECTIONS.Permissions.FutureSoftSearch];
    checkboxFields.forEach((field) => {
        if (field in normalized) {
            normalized[field] = normalized[field] === true || normalized[field] === 'true';
        }
    });
    return normalized;
};
